import { withCompController } from '@wix/editor-elements-integrations';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import type {
  IResponsivePopupPageProps,
  IResponsivePopupPageControllerProps,
  IResponsivePopupPageStateValues,
} from '../ResponsivePopupPage.types';
import { fixLightboxOverlayTouchActionExperiment } from '../experiments';

export default withCompController<
  IResponsivePopupPageProps,
  IResponsivePopupPageControllerProps,
  IResponsivePopupPageProps,
  IResponsivePopupPageStateValues
>(({ mapperProps, stateValues }) => {
  const { experiments = {} } = stateValues;

  return {
    ...mapperProps,
    fixOverlayTouchAction: isExperimentOpen(
      experiments,
      fixLightboxOverlayTouchActionExperiment,
    ),
  };
});
